import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Row, Table, Dropdown, Nav, Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
import { groupTeachingData, getDayNameTHByIndex } from '../utils/teachingUtils'

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');
const StudentAvatar = ({ photo, name }) => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const initial = name ? name.trim().charAt(0) : '?';
  const circleStyle = { width: 28, height: 28, borderRadius: '50%', flexShrink: 0 };
  const src = photo ? `${UPLOAD_BASE}${photo.startsWith('/') ? photo : `/${photo}`}` : null;
  return (
    <>
      <span
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
        onMouseEnter={() => src && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => src && setShowModal(true)}
      >
        {src
          ? <img src={src} alt="" style={{ ...circleStyle, objectFit: 'cover', cursor: 'pointer' }} />
          : <span style={{ ...circleStyle, backgroundColor: '#adb5bd', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initial}</span>
        }
        {src && hovered && (
          <div style={{ position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)', zIndex: 1050, background: '#fff', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.25)', padding: 4 }}>
            <img src={src} alt={name} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, display: 'block' }} />
          </div>
        )}
      </span>
      {src && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
          <Modal.Body className="p-3 text-center">
            <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
            {name && <div className="mt-2 fw-semibold small">{name}</div>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default function ManageTeaching() {
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  // const [classId, setClassId] = useState(null);
  const { c_id } = useParams();
  const { setLoading } = useLoading();

  const [data, setData] = useState({})
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null;
  })
  const [selectedYear, setSelectedYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const [classList, setClassList] = useState([1]);
  const [show, setShow] = useState(false);

  // ฟิลด์สำหรับฟอร์ม
  const [formStudentId, setFormStudentId] = useState("");
  const [st_id, set_stid] = useState("");
  const [formStudentName, setFormStudentName] = useState("");
  const [searchStatus, setSearchStatus] = useState(""); // "", "found", "not_found"
  
  useEffect(() => {
    // get yearId from lastest year in database
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        const list = res.data;
        setYearList(list);

        // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
      let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        
      })
  }, [])

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getClassList`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        setClassList(res.data);
      })
      .catch(err => {
        console.error("Error loading class list:", err);
      });
  }, []);

  // Load teaching data when c_id and yearId change
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [roomId, setRoomId] = useState(null);

  const cidActive = c_id || "1";

  useEffect(() => {
    if (cidActive && yearId) {
      setLoading(true);
      axiosInstance.get(`${process.env.REACT_APP_API}/getRoomListByClassId/${cidActive}/${yearId}`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
        .then(res => {
          if (res.data.length > 0) {
            // console.log("Room list loaded:", res.data);
            setRoomList(res.data);
            // คืนค่าห้องที่จำไว้ของชั้นนี้ (เช่นตอนกดย้อนกลับจากหน้าข้อมูลนักเรียน)
            // ถ้าห้องที่จำไว้ไม่อยู่ในลิสต์ของชั้น/ปีนี้ ถือว่าเปลี่ยนชั้น/ปี → รีเซ็ต
            const savedRoomId = sessionStorage.getItem(`ms_roomId_${cidActive}`);
            const match = savedRoomId ? res.data.find(r => String(r.r_id) === String(savedRoomId)) : null;
            if (match) {
              setRoomId(match.r_id);
              setSelectedRoom(`ชั้น ม.${match.tb_class_c_id}/${match.r_no} ${match.p_code}`);
            } else {
              setRoomId(null);
              setSelectedRoom(null);
            }
          } else {
            setRoomList([]);
            setRoomId(null);
            setSelectedRoom(null);
            Swal.fire({
              icon: 'warning',
              title: 'ไม่พบข้อมูลห้องเรียน',
              text: 'กรุณาเพิ่มห้องเรียนก่อนทำการสอน',
            });
          }
        })
        .catch(err => {
          setRoomList([]);
          setRoomId(null);
          setSelectedRoom(null);
          console.error("Error loading teaching data:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }
  , [cidActive, yearId, setLoading]);

  // Function to handle dropdown change
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id); // ใช้ id สำหรับ query
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`)
      localStorage.setItem('yearId', id); // Save to localStorage
    }
  }

  // ดึงข้อมูลนักเรียน แยกเป็นฟังก์ชัน (เรียกใช้ได้ทั้ง useEffect และหลังเพิ่มนักเรียน)
  const fetchStudents = (rid = roomId) => {
    if (!rid) {
      setData([]);
      return;
    }
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudentDataByRoomId/${rid}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
      .then(res => {
        if (res.data.length > 0) {
          setData(res.data);
        } else {
          setData([]);
        }
      })
      .catch(err => {
        console.error("Error loading student data:", err);
        setData([]);
      })
      .finally(() => setLoading(false));
  };

  // โหลดเมื่อ roomId เปลี่ยน
  useEffect(() => {
    fetchStudents();
  }, [roomId]); 


  // Function to handle room selection
  const handleSelectRoom = (id) => {
    const selectedRoom = roomList.find(r => r.r_id === id);
    if (selectedRoom) {
      setRoomId(id); // ใช้ id สำหรับ query
      setSelectedRoom(`ชั้น ม.${selectedRoom.tb_class_c_id}/${selectedRoom.r_no} ${selectedRoom.p_code}`); // แสดงชั้นเรียนจริง
      sessionStorage.setItem(`ms_roomId_${cidActive}`, id); // จำห้องที่เลือกไว้ต่อชั้น เพื่อคืนค่าเมื่อกดย้อนกลับ
    }
  }


  // Import from previous year
  const [showImportModal, setShowImportModal] = useState(false);
  const [importYearId, setImportYearId] = useState(null);
  const [importYearLabel, setImportYearLabel] = useState('');
  const [importRoomList, setImportRoomList] = useState([]);
  const [importRoomId, setImportRoomId] = useState(null);
  const [importRoomLabel, setImportRoomLabel] = useState('');
  const [importStudents, setImportStudents] = useState([]);

  const handleOpenImportModal = () => {
    setImportYearId(null);
    setImportYearLabel('');
    setImportRoomList([]);
    setImportRoomId(null);
    setImportRoomLabel('');
    setImportStudents([]);
    setShowImportModal(true);
  };

  const handleSelectImportYear = (id, year_year) => {
    setImportYearId(id);
    setImportYearLabel(`ปีการศึกษา ${year_year}`);
    setImportRoomId(null);
    setImportRoomLabel('');
    setImportStudents([]);
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomListByYearId/${id}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    }).then(res => setImportRoomList(res.data)).catch(() => setImportRoomList([]));
  };

  const handleSelectImportRoom = (id, label) => {
    setImportRoomId(id);
    setImportRoomLabel(label);
    setImportStudents([]);
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudentDataByRoomId/${id}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    }).then(res => {
      setImportStudents((res.data || []).map(s => ({ ...s, selected: true })));
    }).catch(() => setImportStudents([]));
  };

  const handleToggleImportStudent = (st_id) => {
    setImportStudents(prev => prev.map(s => s.tb_student_st_id === st_id ? { ...s, selected: !s.selected } : s));
  };

  const handleToggleAllImport = (checked) => {
    setImportStudents(prev => prev.map(s => ({ ...s, selected: checked })));
  };

  // Import new students (st_status = 3)
  const [showNewImportModal, setShowNewImportModal] = useState(false);
  const [newStudentList, setNewStudentList] = useState([]);
  const [filterClass, setFilterClass] = useState(null);
  const [filterProgram, setFilterProgram] = useState(null);
  const [filterGender, setFilterGender] = useState(null);

  const handleOpenNewImportModal = () => {
    const currentRoom = roomList.find(r => r.r_id === roomId);
    setNewStudentList([]);
    setFilterClass(`h${cidActive}`);
    setFilterProgram(currentRoom?.p_code?.toLowerCase() || null);
    setFilterGender(null);
    setShowNewImportModal(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getNewStudents`, {
      headers: { authorization: `Bearer ${getToken()}` }
    }).then(res => {
      setNewStudentList((res.data || []).map(s => ({ ...s, selected: false })));
    }).catch(() => setNewStudentList([]));
  };

  const handleToggleNewStudent = (st_id) => {
    setNewStudentList(prev => prev.map(s => s.tb_student_st_id === st_id ? { ...s, selected: !s.selected } : s));
  };

  const handleToggleAllNew = (checked) => {
    setNewStudentList(prev => prev.map(s => {
      const classMatch = !filterClass || s.regis_academicClass === filterClass;
      const programMatch = !filterProgram || s.regis_academicProgram === filterProgram;
      const genderMatch = !filterGender || s.st_gen === filterGender;
      return (classMatch && programMatch && genderMatch) ? { ...s, selected: checked } : s;
    }));
  };

  const handleBulkImportNew = async () => {
    const selected = newStudentList.filter(s => s.selected).map(s => s.tb_student_st_id);
    if (selected.length === 0) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกนักเรียน', text: 'กรุณาเลือกนักเรียนอย่างน้อย 1 คน' });
      return;
    }
    setLoading(true);
    try {
      const { data: result } = await axiosInstance.post(
        `${process.env.REACT_APP_API}/bulkAddStudentsToRoom`,
        { stIds: selected, roomId },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      setShowNewImportModal(false);
      fetchStudents(roomId);
      Swal.fire({ icon: 'success', title: 'นำเข้าสำเร็จ', text: `เพิ่มนักเรียน ${result.inserted} คน`, timer: 2000, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถนำเข้านักเรียนได้' });
    } finally {
      setLoading(false);
    }
  };

  const handleBulkImport = async () => {
    const selected = importStudents.filter(s => s.selected).map(s => s.tb_student_st_id);
    if (selected.length === 0) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกนักเรียน', text: 'กรุณาเลือกนักเรียนอย่างน้อย 1 คน' });
      return;
    }
    setLoading(true);
    try {
      const { data: result } = await axiosInstance.post(
        `${process.env.REACT_APP_API}/bulkAddStudentsToRoom`,
        { stIds: selected, roomId },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      setShowImportModal(false);
      fetchStudents(roomId);
      Swal.fire({ icon: 'success', title: 'นำเข้าสำเร็จ', text: `เพิ่มนักเรียน ${result.inserted} คน`, timer: 2000, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถนำเข้านักเรียนได้' });
    } finally {
      setLoading(false);
    }
  };

  // ── Import from Excel: match by st_idnumber → st_id, then add to current room ──
  const excelInputRef = useRef(null);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelFileName, setExcelFileName] = useState('');
  const [excelMatched, setExcelMatched] = useState([]); // [{ st_id, st_idnumber, st_name, selected }]
  const [excelNotFound, setExcelNotFound] = useState([]); // [st_idnumber, ...]

  // คอลัมน์ที่อาจใช้เก็บเลขประจำตัวนักเรียน เรียงจาก "เฉพาะเจาะจงที่สุด" ไป "กว้างที่สุด"
  // คำกว้าง 'รหัส' อยู่ท้ายสุด เพื่อไม่ให้แย่งจับคอลัมน์เช่น รหัสห้อง/รหัสวิชา ก่อนคอลัมน์ที่ใช่
  const ID_COLUMN_KEYWORDS = ['เลขประจำตัว', 'เลขประจําตัว', 'รหัสนักเรียน', 'รหัสประจำตัว', 'st_idnumber', 'idnumber', 'รหัส'];

  // ดึงรายการเลขประจำตัวจาก worksheet
  // อ่านเป็นตาราง (array-of-arrays) เพื่อสแกนหา "แถวหัวตาราง" + "คอลัมน์เลขประจำตัว" เอง
  // รองรับไฟล์ที่มีแถวหัวเรื่อง/หัวตารางคร่อมอยู่ด้านบน และคอลัมน์อยู่ตำแหน่งใดก็ได้
  const extractIdNumbers = (worksheet) => {
    const aoa = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false, raw: false, defval: '' });
    if (aoa.length === 0) return [];
    const norm = (s) => String(s).toLowerCase().replace(/\s/g, '');

    // หาแถวหัวตาราง + คอลัมน์เลขประจำตัว ตามลำดับความสำคัญของคีย์เวิร์ด
    let headerRow = -1, idCol = -1;
    for (const t of ID_COLUMN_KEYWORDS) {
      const kw = norm(t);
      for (let r = 0; r < aoa.length && headerRow === -1; r++) {
        const row = aoa[r] || [];
        for (let c = 0; c < row.length; c++) {
          const cell = norm(row[c]);
          if (cell && cell.includes(kw)) { headerRow = r; idCol = c; break; }
        }
      }
      if (headerRow !== -1) break;
    }

    // เก็บค่าจากคอลัมน์ที่เจอ (ถ้าไม่เจอหัวตารางเลย → เดาเป็นคอลัมน์แรก)
    const dataRows = idCol !== -1 ? aoa.slice(headerRow + 1) : aoa;
    const col = idCol !== -1 ? idCol : 0;
    return dataRows
      .map(row => String(row?.[col] ?? '').trim().replace(/[,\s]/g, '')) // ตัด comma/ช่องว่างที่ Excel อาจแทรกมา
      .filter(Boolean);
  };

  const handlePickExcel = () => {
    if (!roomId) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกห้องเรียน', text: 'กรุณาเลือกห้องก่อนนำเข้าจาก Excel' });
      return;
    }
    excelInputRef.current?.click();
  };

  // ดึงเลขประจำตัวจากชีตที่เลือก → จับคู่เป็น st_id → เปิด modal พรีวิว
  const resolveSheetAndPreview = async (worksheet, label) => {
    const idnumbers = extractIdNumbers(worksheet);
    if (idnumbers.length === 0) {
      Swal.fire({ icon: 'warning', title: 'ไม่พบเลขประจำตัวในแท็บนี้', text: 'ตรวจสอบว่าแท็บที่เลือกมีคอลัมน์เลขประจำตัวนักเรียน' });
      return;
    }
    setLoading(true);
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API}/resolveStudentsByIdNumbers`,
        { idnumbers },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      setExcelFileName(label);
      setExcelMatched((data.matched || []).map(s => ({ ...s, selected: true })));
      setExcelNotFound(data.notFound || []);
      setShowExcelModal(true);
    } catch (err) {
      console.error('Error resolving students:', err);
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถจับคู่นักเรียนได้' });
    } finally {
      setLoading(false);
    }
  };

  const handleExcelFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // เผื่อเลือกไฟล์เดิมซ้ำ
    if (!file) return;
    if (!roomId) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกห้องเรียน', text: 'กรุณาเลือกห้องก่อนนำเข้าจาก Excel' });
      return;
    }

    let wb;
    try {
      const buf = await file.arrayBuffer();
      wb = XLSX.read(buf, { type: 'array' });
    } catch (err) {
      console.error('Error reading excel:', err);
      Swal.fire({ icon: 'error', title: 'อ่านไฟล์ไม่สำเร็จ', text: 'ไฟล์อาจไม่ใช่ Excel ที่ถูกต้องหรือเสียหาย' });
      return;
    }

    const sheetNames = wb.SheetNames || [];
    if (sheetNames.length === 0) {
      Swal.fire({ icon: 'warning', title: 'ไม่พบข้อมูลในไฟล์' });
      return;
    }

    // ถ้ามีหลายแท็บ ให้เลือกแท็บที่ตรงกับห้องที่กำลังจัดการ
    let sheetName = sheetNames[0];
    if (sheetNames.length > 1) {
      const { value } = await Swal.fire({
        title: 'เลือกแท็บที่จะนำเข้า',
        text: `ไฟล์นี้มี ${sheetNames.length} แท็บ — เลือกแท็บให้ตรงกับ ${selectedRoom || 'ห้องที่เลือกไว้'}`,
        input: 'select',
        inputOptions: sheetNames.reduce((o, n) => { o[n] = n; return o; }, {}),
        inputValue: sheetName,
        showCancelButton: true,
        confirmButtonText: 'ถัดไป',
        cancelButtonText: 'ยกเลิก',
      });
      if (!value) return; // ยกเลิก
      sheetName = value;
    }

    await resolveSheetAndPreview(wb.Sheets[sheetName], `${file.name} — ${sheetName}`);
  };

  const handleToggleExcelStudent = (st_id) => {
    setExcelMatched(prev => prev.map(s => s.st_id === st_id ? { ...s, selected: !s.selected } : s));
  };

  const handleToggleAllExcel = (checked) => {
    setExcelMatched(prev => prev.map(s => ({ ...s, selected: checked })));
  };

  const handleBulkImportExcel = async () => {
    const selected = excelMatched.filter(s => s.selected).map(s => s.st_id);
    if (selected.length === 0) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกนักเรียน', text: 'กรุณาเลือกนักเรียนอย่างน้อย 1 คน' });
      return;
    }
    setLoading(true);
    try {
      const { data: result } = await axiosInstance.post(
        `${process.env.REACT_APP_API}/bulkAddStudentsToRoom`,
        { stIds: selected, roomId },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      setShowExcelModal(false);
      fetchStudents(roomId);
      Swal.fire({ icon: 'success', title: 'นำเข้าสำเร็จ', text: `เพิ่มนักเรียน ${result.inserted} คน`, timer: 2000, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถนำเข้านักเรียนได้' });
    } finally {
      setLoading(false);
    }
  };

  const [selectedSemester, setSelectedSemester] = useState(null);
  const [availableSubjects, setAvailableSubjects] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [periodList, setPeriodList] = useState([]);

  // Transfer modal state
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferStudyId, setTransferStudyId] = useState(null);
  const [transferStudentName, setTransferStudentName] = useState('');
  const [allRoomList, setAllRoomList] = useState([]);
  const [selectedTransferRoomId, setSelectedTransferRoomId] = useState('');

  useEffect(() => {
    if (!yearId) return;
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomListByYearId/${yearId}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    }).then(res => setAllRoomList(res.data || [])).catch(() => setAllRoomList([]));
  }, [yearId]);

  // การเปลี่ยนสถานะนักเรียนทำที่เมนู "จำหน่ายนักเรียน" (/registration/student-exit)
  // ที่เดียว เพราะที่นั่นบังคับให้ระบุวันที่ สาเหตุ และปลายทางที่ไปเรียนต่อไปพร้อมกัน
  // การพลิกสถานะดิบๆ จากหน้านี้ทำให้ได้แถวที่ออกจากทะเบียนโดยไม่มีใครรู้ว่าเพราะอะไร

  const handleRemoveStudent = (st_id, st_name, st_idnumber) => {
    Swal.fire({
      icon: 'warning',
      title: 'ยืนยันการลบ',
      html: `ลบ <strong>${st_idnumber} ${st_name}</strong> ออกจากห้องนี้?`,
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#dc3545',
    }).then(result => {
      if (!result.isConfirmed) return;
      setLoading(true);
      axiosInstance.post(`${process.env.REACT_APP_API}/removeStudentFromRoom`,
        { st_id, roomId },
        { headers: { authorization: `Bearer ${getToken()}` } }
      ).then(() => {
        fetchStudents(roomId);
      }).catch(err => {
        Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถลบได้' });
      }).finally(() => setLoading(false));
    });
  };

  const handleOpenTransferModal = (study_id, st_name) => {
    setTransferStudyId(study_id);
    setTransferStudentName(st_name);
    setSelectedTransferRoomId('');
    setShowTransferModal(true);
  };

  const handleSetTransfer = async () => {
    if (!selectedTransferRoomId) {
      Swal.fire({ icon: 'warning', title: 'ยังไม่ได้เลือกห้องปลายทาง' });
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post(
        `${process.env.REACT_APP_API}/setStudentTransfer`,
        { study_id: transferStudyId, transfer_room_id: Number(selectedTransferRoomId) },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      setShowTransferModal(false);
      fetchStudents(roomId);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถบันทึกการย้ายได้' });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelTransfer = async (study_id) => {
    setLoading(true);
    try {
      await axiosInstance.post(
        `${process.env.REACT_APP_API}/setStudentTransfer`,
        { study_id, transfer_room_id: null },
        { headers: { authorization: `Bearer ${getToken()}` } }
      );
      fetchStudents(roomId);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.response?.data?.message || 'ไม่สามารถยกเลิกการย้ายได้' });
    } finally {
      setLoading(false);
    }
  };

  // เปิด modal สำหรับ add/edit
  const handleShow = () => {
    setShow(true);
  }

  const handleClose = () => {
    setFormStudentId("");
    setFormStudentName("");
    setSearchStatus("");
    setShow(false);
  }

  // ฟังก์ชันสำหรับเพิ่มนักเรียนเข้าห้องเรียน
  const handleAddStudent = async () => {
    if (!formStudentId) {
      Swal.fire({
        icon:'warning',
        title:'กรุณากรอกเลขประจำตัวนักเรียน',
        text:'กรุณากรอกเลขประจำตัวนักเรียนก่อนทำการเพิ่ม'
      });
      return;
    }
    if (!roomId) {
      Swal.fire({
        icon:'warning',
        title:'ยังไม่ได้เลือกห้องเรียน',
        text:'กรุณาเลือกห้องก่อนเพิ่มนักเรียน'
      });
      return;
    }

    const payload = {
      st_id,
      yearId,
      studentId: formStudentId,
      studentName: formStudentName,
      roomId,
      searchStatus
    };

    try {
      setLoading(true);
      //console.log('[addStudentToRoom] payload =>', payload);

      // ถ้า axiosInstance กำหนด baseURL แล้ว (เช่น process.env.REACT_APP_API) ให้ใช้แค่ '/addStudentToRoom'
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API}/addStudentToRoom`,
        payload,
        { headers: { authorization: `Bearer ${getToken()}` } }
      );

      //console.log('[addStudentToRoom] response =>', data);

      if (data && data.success === true) {
        Swal.fire({
          icon:'success',
            title:'เพิ่มนักเรียนสำเร็จ',
            text: data.message || 'นักเรียนถูกเพิ่มเข้าห้องเรียนเรียบร้อยแล้ว'
        });
        // เคลียร์ฟอร์ม
        setFormStudentId('');
        setFormStudentName('');
        set_stid('');
        setSearchStatus('');
        setShow(false);

        // Reload รายชื่อนักเรียนของห้องเดิม
        fetchStudents(roomId);
      } else {
        Swal.fire({
          icon:'error',
          title:'ไม่สามารถเพิ่มนักเรียนได้',
          text: data?.message || 'เซิร์ฟเวอร์ไม่ได้ส่ง success:true'
        });
      }
    } catch (err) {
      if (err.response?.status === 409 && err.response?.data?.duplicate) {
        Swal.fire({ icon: 'info', title: 'มีอยู่แล้ว', text: err.response.data.message });
      } else if (err.response?.status === 409 && err.response?.data?.found) {
        Swal.fire({ icon: 'warning', title: 'นักเรียนอยู่ในห้องอื่นแล้ว', text: err.response.data.message });
      } else {
        console.error('[addStudentToRoom] error =>', err.response?.status, err.response?.data, err);
        Swal.fire({
          icon:'error',
          title:'เกิดข้อผิดพลาด',
          text: err.response?.data?.message || 'ไม่สามารถเพิ่มนักเรียนได้ กรุณาลองใหม่'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // ฟังก์ชันสำหรับค้นหานักเรียน
  const handleFindStudent = () => {
    if (!formStudentId) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกเลขประจำตัวนักเรียน',
        text: 'กรุณากรอกเลขประจำตัวนักเรียนก่อนทำการค้นหา',
      });
      return;
    }
    
    setLoading(true);
    setSearchStatus(""); // Reset status
    
    axiosInstance.get(`${process.env.REACT_APP_API}/findStudentByStudentId/${formStudentId}`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        if (res.data.st_id) {
          set_stid(res.data.st_id);
          setFormStudentName(res.data.st_name);
          setFormStudentId(res.data.st_idnumber);
          setSearchStatus("found"); // ตั้งสถานะเป็นพบ
        } else {
          Swal.fire({
            icon: 'warning',
            title: res.data.title || 'ไม่พบข้อมูลนักเรียน',
            text: res.data.message || 'ไม่พบข้อมูลนักเรียนที่มีเลขประจำตัวนี้',
          });
          setFormStudentName("");
          set_stid("");
          setSearchStatus("not_found"); // ตั้งสถานะเป็นไม่พบ
        }
      })
      .catch(err => {
        console.error("Error finding student:", err);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถค้นหานักเรียนได้ กรุณาลองใหม่อีกครั้ง',
        });
        setSearchStatus("not_found");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const escHtml = (str) => String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  const handlePrintNameList = () => {
    const students = Array.isArray(data) ? data : []
    const currentRoom = roomList.find(r => String(r.r_id) === String(roomId))
    const c_class = currentRoom?.tb_class_c_id ?? ''
    const r_no = currentRoom?.r_no ?? ''
    const yearDisplay = (selectedYear || '').replace('ปีการศึกษา', '').trim()

    const blankCols = 10 // ช่องว่างสำหรับบันทึก/ทำเครื่องหมายเอง
    // คอลัมน์รวมต้องเท่ากับ 100% เพื่อให้พอดีกับความกว้างกระดาษ (แนวตั้ง)
    const infoPct = 5 + 12 + 28 + 8 + 10 // เลขที่ + เลขประจำตัว + ชื่อ + ชั้นศาสนา + หอพัก
    const blankPct = (100 - infoPct) / blankCols

    const colgroup = `<colgroup>
        <col style="width:5%;" />
        <col style="width:12%;" />
        <col style="width:28%;" />
        <col style="width:8%;" />
        <col style="width:10%;" />
        ${Array.from({ length: blankCols }).map(() => `<col style="width:${blankPct}%;" />`).join('')}
      </colgroup>`

    const blankHeadCells = Array.from({ length: blankCols }).map(() => `<th></th>`).join('')
    const blankBodyCells = Array.from({ length: blankCols }).map(() => `<td></td>`).join('')

    const bodyRows = students.length > 0
      ? students.map((s, i) => {
          const isWithdrawn = s.st_status === '0'
          const isTransferred = !!s.transfer_room_id
          const rowClass = isWithdrawn ? ' class="hl-withdrawn"' : (isTransferred ? ' class="hl-transferred"' : '')
          let note = ''
          if (isWithdrawn) note = ' (จำหน่ายแล้ว)'
          else if (isTransferred) note = ` (ย้ายไป ม.${escHtml(s.transfer_class_id)}/${escHtml(s.transfer_room_no)})`
          return `<tr${rowClass}>
          <td class="c">${i + 1}</td>
          <td class="c">${escHtml(s.st_idnumber)}</td>
          <td class="name">${escHtml(s.st_name)}${note ? `<span class="note">${note}</span>` : ''}</td>
          <td class="c">${escHtml(s.ic_class ? `${s.ic_class}/${s.isl_room_no}` : '-')}</td>
          <td class="c">${escHtml(s.dorm_name || '-')}</td>
          ${blankBodyCells}
        </tr>`
        }).join('')
      : `<tr><td colspan="${5 + blankCols}" class="c">ไม่พบข้อมูล</td></tr>`

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>รายชื่อนักเรียน ม.${escHtml(c_class)}/${escHtml(r_no)}</title>
      <style>
        @page { size: A4 portrait; margin: 8mm; }
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; }
        body { font-family: 'Cordia New', 'TH Sarabun New', Tahoma, Arial, sans-serif; font-size: 16px; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        h3 { text-align: center; margin: 0 0 6px 0; font-size: 16px; }
        table { border-collapse: collapse; width: 100%; table-layout: fixed; }
        th, td { border: 1px solid #000; padding: 2px 3px; overflow: hidden; word-wrap: break-word; }
        .head-table { margin-bottom: 6px; }
        .head-table td { vertical-align: middle; }
        .head-table .label { background: #f0f0f0; white-space: nowrap; font-weight: 600; }
        thead th { text-align: center; vertical-align: middle; background: #f0f0f0; }
        tbody .c { text-align: center; }
        tbody .name { padding-left: 6px; }
        tbody tr { height: 22px; }
        tbody .note { font-size: 11px; color: #555; }
        tbody .hl-withdrawn { background: #f8d7da; }
        tbody .hl-transferred { background: #fff3cd; }
      </style></head>
      <body onload="window.print()">
        <h3>โรงเรียนวัฒนธรรมอิสลาม</h3>
        <table class="head-table">
          <colgroup>
            <col style="width:14%;" /><col style="width:36%;" /><col style="width:16%;" /><col style="width:34%;" />
          </colgroup>
          <tr>
            <td class="label">ปีการศึกษา</td>
            <td>${escHtml(yearDisplay)}</td>
            <td class="label">ห้องเรียน</td>
            <td>ม.${escHtml(c_class)}/${escHtml(r_no)}</td>
          </tr>
        </table>
        <table>
          ${colgroup}
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>เลขประจำตัว<br/>นักเรียน</th>
              <th>ชื่อ - สกุล นักเรียน</th>
              <th>ชั้นศาสนา</th>
              <th>หอพัก</th>
              ${blankHeadCells}
            </tr>
          </thead>
          <tbody>${bodyRows}</tbody>
        </table>
      </body></html>`

    const win = window.open('', '_blank', 'width=1200,height=900')
    win.document.write(html)
    win.document.close()
  }

  return (
    <React.Fragment>
      <input
        type="file"
        ref={excelInputRef}
        accept=".xlsx,.xls"
        onChange={handleExcelFile}
        style={{ display: 'none' }}
      />
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ทะเบียนและหลักสูตร</Link></li>
              <li className="breadcrumb-item active" aria-current="page">จัดการนักเรียน</li>
            </ol>
            <h4 className="main-title mb-0">จัดการนักเรียน</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
              {yearList.map(item => (
                <Dropdown.Item key={item.year_id} onClick={() => handleSelectYear(item.year_id)}>
                  ปีการศึกษา {item.year_year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <Row className="g-12 mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <Nav variant="tabs" defaultActiveKey={`/registration/manage-students/${cidActive}`}>
              {classList.map((cls, index) => (
                <Nav.Item key={cls.c_id + '-' + index}>
                  <Nav.Link
                    as={Link}
                    to={`/registration/manage-students/${cls.c_id}`}
                    active={String(cidActive) === String(cls.c_id)}
                  >
                    {cls.c_class}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <Card className="card-one">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Card.Title as="h6" className="mb-0">{selectedYear}</Card.Title>
              <div className="d-flex align-items-center gap-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handlePrintNameList}
                  disabled={!roomId || !data || data.length === 0}
                >
                  <i className="ri-printer-line me-1"></i>พิมพ์รายชื่อ
                </Button>
                <span className="text-muted">ชั้นเรียน:</span>
                <Dropdown>
                  <Dropdown.Toggle variant="primary" id="dropdown-basic">
                    {selectedRoom || "เลือกชั้นเรียน"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {roomList.map(item => (
                      <Dropdown.Item key={item.r_id} onClick={() => handleSelectRoom(item.r_id)}>
                        ม. {item.tb_class_c_id}/{item.r_no} ({item.p_code})
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Card.Header>
            <Card.Body className="p-3">
              { roomId ? (
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width: "50px" }}>เลขที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>เลขประจำตัว</th>
                      <th scope="col">ชื่อ-สกุล</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>ช้ันศาสนา</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>หอพัก</th>
                      <th scope="col" className="text-center" style={{ width: "120px" }}>สถานะ</th>
                      <th scope="col" className="text-center" style={{ width: "220px" }}>
                        {data && data.length === 0 ? (
                          <div className="d-flex flex-column align-items-center gap-1">
                            <div className="d-flex gap-1">
                              <Button variant="outline-info" size="sm" onClick={handleOpenImportModal}>
                                <i className="ri-download-2-line"></i> ปีก่อน
                              </Button>
                              <Button variant="outline-warning" size="sm" onClick={handleOpenNewImportModal}>
                                <i className="ri-user-add-line"></i> นักเรียนใหม่
                              </Button>
                              <Button variant="outline-success" size="sm" onClick={handlePickExcel}>
                                <i className="ri-file-excel-2-line"></i> นำเข้า Excel
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex gap-1 justify-content-center">
                            <Button variant="outline-warning" size="sm" onClick={handleOpenNewImportModal}>
                              <i className="ri-user-add-line"></i> นักเรียนใหม่
                            </Button>
                            <Button variant="outline-success" size="sm" onClick={handlePickExcel}>
                              <i className="ri-file-excel-2-line"></i> นำเข้า Excel
                            </Button>
                            <Button variant="success" size="sm" onClick={() => handleShow()}>
                              <i className="ri-add-line"></i> เพิ่มนักเรียน
                            </Button>
                          </div>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.length > 0 ? (
                      data.map((data, index) => (
                        <tr key={data.tb_student_st_id} className={data.st_status === '0' ? 'table-danger' : data.transfer_room_id ? 'table-warning' : ''}>
                          <th scope="row" className="text-center">{++index}</th>
                          <td className="text-center">{data.st_idnumber}</td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <StudentAvatar photo={data.st_photo} name={data.st_name} />
                              <span>
                                {data.st_name}
                                {data.transfer_room_id && (
                                  <small className="text-muted ms-2">(ย้ายไป ม.{data.transfer_class_id}/{data.transfer_room_no})</small>
                                )}
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            {data.ic_class ? `${data.ic_class}/${data.isl_room_no}` : '-'}
                          </td>
                          <td className="text-center">{data.dorm_name || '-'}</td>
                          <td className={
                            data.st_status === '0' ? 'text-center text-danger'
                            : data.st_status === '1' ? 'text-center text-primary'
                            : 'text-center text-success'
                          }>
                            {data.status_text}
                          </td>
                          <td className="text-center">
                            <div className="d-flex gap-2 justify-content-center flex-wrap">
                              <Link to={`/advisor/student-info/${data.tb_student_st_id}`}><i className="ri-contacts-book-2-line"> แสดงข้อมูลนักเรียน</i></Link>
                              {data.transfer_room_id ? (
                                <span className="text-warning" style={{ cursor: 'pointer' }} onClick={() => handleCancelTransfer(data.study_id)}><i className="ri-arrow-go-back-line"></i> ยกเลิกย้าย</span>
                              ) : (
                                <span className="text-info" style={{ cursor: 'pointer' }} onClick={() => handleOpenTransferModal(data.study_id, data.st_name)}><i className="ri-swap-line"></i> ย้ายห้อง</span>
                              )}
                              <span className="text-danger" style={{ cursor: 'pointer' }} onClick={() => handleRemoveStudent(data.tb_student_st_id, data.st_name, data.st_idnumber)}><i className="ri-user-unfollow-line"></i> นำออก</span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center my-3">
                  <span className="text-muted">กรุณาเลือกชั้นเรียนก่อน</span>
                </div>
              )}
            </Card.Body>
          </Card>
        </Row>
        <Footer />
      </div>

      {/* Transfer Modal */}
      <Modal show={showTransferModal} onHide={() => setShowTransferModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ย้ายห้อง — {transferStudentName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">เลือกห้องปลายทาง:</div>
          <select
            className="form-select"
            value={selectedTransferRoomId}
            onChange={e => setSelectedTransferRoomId(e.target.value)}
          >
            <option value="">-- เลือกห้องปลายทาง --</option>
            {allRoomList.filter(r => r.r_id !== roomId).map(r => (
              <option key={r.r_id} value={r.r_id}>
                ม.{r.tb_class_c_id}/{r.r_no} ({r.p_code})
              </option>
            ))}
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTransferModal(false)}>ยกเลิก</Button>
          <Button variant="primary" onClick={handleSetTransfer}>บันทึก</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNewImportModal} onHide={() => setShowNewImportModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>นำเข้านักเรียนใหม่ — ชั้น ม.{cidActive}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            const classMap = { h1: 'ม.1', h2: 'ม.2', h3: 'ม.3', h4: 'ม.4', h5: 'ม.5', h6: 'ม.6' };
            const classes = [...new Set(newStudentList.map(s => s.regis_academicClass).filter(Boolean))].sort();
            const programs = [...new Set(newStudentList.map(s => s.regis_academicProgram).filter(Boolean))].sort();
            const visible = newStudentList.filter(s =>
              (!filterClass || s.regis_academicClass === filterClass) &&
              (!filterProgram || s.regis_academicProgram === filterProgram) &&
              (!filterGender || s.st_gen === filterGender)
            );
            const selectedCount = newStudentList.filter(s => s.selected).length;

            if (newStudentList.length === 0) {
              return (
                <div className="text-center text-muted py-4">
                  <i className="ri-user-search-line fs-3 d-block mb-2"></i>
                  ไม่พบนักเรียนใหม่ในระบบ
                </div>
              );
            }
            return (
              <>
                {classes.length > 0 && (
                  <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                    <span className="text-muted fs-sm fw-semibold">ชั้น:</span>
                    <Button variant={filterClass === null ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterClass(null)}>
                      ทั้งหมด ({newStudentList.length})
                    </Button>
                    {classes.map(c => (
                      <Button key={c} variant={filterClass === c ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterClass(c)}>
                        {classMap[c] || c} ({newStudentList.filter(s => s.regis_academicClass === c).length})
                      </Button>
                    ))}
                  </div>
                )}
                {programs.length > 0 && (
                  <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                    <span className="text-muted fs-sm fw-semibold">โปรแกรม:</span>
                    <Button variant={filterProgram === null ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterProgram(null)}>
                      ทั้งหมด
                    </Button>
                    {programs.map(p => (
                      <Button key={p} variant={filterProgram === p ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterProgram(p)}>
                        {p.toUpperCase()} ({newStudentList.filter(s => s.regis_academicProgram === p && (!filterClass || s.regis_academicClass === filterClass)).length})
                      </Button>
                    ))}
                  </div>
                )}
                <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                  <span className="text-muted fs-sm fw-semibold">เพศ:</span>
                  <Button variant={filterGender === null ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterGender(null)}>
                    ทั้งหมด
                  </Button>
                  <Button variant={filterGender === 'm' ? 'primary' : 'outline-secondary'} size="sm" onClick={() => setFilterGender('m')}>
                    ชาย ({newStudentList.filter(s => s.st_gen === 'm' && (!filterClass || s.regis_academicClass === filterClass) && (!filterProgram || s.regis_academicProgram === filterProgram)).length})
                  </Button>
                  <Button variant={filterGender === 'f' ? 'danger' : 'outline-danger'} size="sm" onClick={() => setFilterGender('f')}>
                    หญิง ({newStudentList.filter(s => s.st_gen === 'f' && (!filterClass || s.regis_academicClass === filterClass) && (!filterProgram || s.regis_academicProgram === filterProgram)).length})
                  </Button>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted fs-sm">
                    แสดง {visible.length} คน — เลือกแล้ว {selectedCount} คน
                  </span>
                  <div className="d-flex gap-2">
                    <Button variant="outline-primary" size="sm" onClick={() => handleToggleAllNew(true)}>เลือกทั้งหมด</Button>
                    <Button variant="outline-secondary" size="sm" onClick={() => handleToggleAllNew(false)}>ล้างการเลือก</Button>
                  </div>
                </div>
                <div style={{ maxHeight: 360, overflowY: 'auto' }}>
                  <Table responsive hover size="sm" className="mb-0">
                    <thead className="table-secondary">
                      <tr>
                        <th style={{ width: 40 }} className="text-center">#</th>
                        <th style={{ width: 120 }} className="text-center">เลขประจำตัว</th>
                        <th>ชื่อ-สกุล</th>
                        <th style={{ width: 60 }} className="text-center">เพศ</th>
                        <th style={{ width: 60 }} className="text-center">ชั้น</th>
                        <th style={{ width: 80 }} className="text-center">โปรแกรม</th>
                        <th style={{ width: 50 }} className="text-center">เลือก</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visible.length > 0 ? visible.map((s, idx) => (
                        <tr key={s.tb_student_st_id} className={!s.selected ? 'text-muted' : ''}>
                          <td className="text-center">{idx + 1}</td>
                          <td className="text-center">{s.st_idnumber || '-'}</td>
                          <td>{s.st_name}</td>
                          <td className="text-center">{s.st_gen === 'm' ? 'ชาย' : s.st_gen === 'f' ? 'หญิง' : '-'}</td>
                          <td className="text-center">{classMap[s.regis_academicClass] || s.regis_academicClass || '-'}</td>
                          <td className="text-center">{s.regis_academicProgram?.toUpperCase() || '-'}</td>
                          <td className="text-center">
                            <input type="checkbox" checked={s.selected} onChange={() => handleToggleNewStudent(s.tb_student_st_id)} />
                          </td>
                        </tr>
                      )) : (
                        <tr><td colSpan={7} className="text-center text-muted py-3">ไม่มีข้อมูลสำหรับตัวกรองที่เลือก</td></tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNewImportModal(false)}>ยกเลิก</Button>
          <Button
            variant="success"
            onClick={handleBulkImportNew}
            disabled={newStudentList.filter(s => s.selected).length === 0}
          >
            <i className="ri-user-add-line me-1"></i>
            นำเข้า {newStudentList.filter(s => s.selected).length} คน
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showImportModal} onHide={() => setShowImportModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>ดึงนักเรียนจากปีก่อน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-3 mb-3 flex-wrap">
            <div>
              <label className="form-label fw-semibold">เลือกปีการศึกษาต้นทาง</label>
              <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" size="sm">
                  {importYearLabel || 'เลือกปีการศึกษา'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {yearList.filter(y => String(y.year_id) !== String(yearId)).map(y => (
                    <Dropdown.Item key={y.year_id} onClick={() => handleSelectImportYear(y.year_id, y.year_year)}>
                      ปีการศึกษา {y.year_year}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {importYearId && (
              <div>
                <label className="form-label fw-semibold">เลือกห้องเรียนต้นทาง</label>
                <Dropdown>
                  <Dropdown.Toggle variant="outline-secondary" size="sm">
                    {importRoomLabel || 'เลือกห้องเรียน'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {importRoomList.map(r => (
                      <Dropdown.Item key={r.r_id} onClick={() => handleSelectImportRoom(r.r_id, `ม.${r.tb_class_c_id}/${r.r_no}${r.p_code ? ` (${r.p_code})` : ''}`)}>
                        ม.{r.tb_class_c_id}/{r.r_no}{r.p_code ? ` (${r.p_code})` : ''}{r.t_name ? ` — ${r.t_name}` : ''}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>

          {importStudents.length > 0 && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted fs-sm">พบ {importStudents.length} คน — เลือก {importStudents.filter(s => s.selected).length} คน</span>
                <div className="d-flex gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={() => handleToggleAllImport(true)}>เลือกทั้งหมด</Button>
                  <Button variant="outline-secondary" size="sm" onClick={() => handleToggleAllImport(false)}>ล้างการเลือก</Button>
                </div>
              </div>
              <div style={{ maxHeight: 360, overflowY: 'auto' }}>
                <Table responsive hover size="sm" className="mb-0">
                  <thead className="table-secondary">
                    <tr>
                      <th style={{ width: 40 }} className="text-center">#</th>
                      <th style={{ width: 120 }} className="text-center">เลขประจำตัว</th>
                      <th>ชื่อ-สกุล</th>
                      <th style={{ width: 60 }} className="text-center">เลือก</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importStudents.map((s, idx) => (
                      <tr key={s.tb_student_st_id} className={!s.selected ? 'text-muted' : ''}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-center">{s.st_idnumber}</td>
                        <td>{s.st_name}</td>
                        <td className="text-center">
                          <input type="checkbox" checked={s.selected} onChange={() => handleToggleImportStudent(s.tb_student_st_id)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {importRoomId && importStudents.length === 0 && (
            <div className="text-center text-muted py-3">ไม่พบนักเรียนในห้องนี้</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImportModal(false)}>ยกเลิก</Button>
          <Button
            variant="success"
            onClick={handleBulkImport}
            disabled={importStudents.filter(s => s.selected).length === 0}
          >
            <i className="ri-download-2-line me-1"></i>
            นำเข้า {importStudents.filter(s => s.selected).length} คน
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showExcelModal} onHide={() => setShowExcelModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>นำเข้าจาก Excel{selectedRoom ? ` — ${selectedRoom}` : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-muted fs-sm mb-3">
            <i className="ri-file-excel-2-line me-1"></i>{excelFileName}
            {' — '}จับคู่จากเลขประจำตัว: พบ <span className="text-success fw-semibold">{excelMatched.length}</span> คน
            {excelNotFound.length > 0 && <>, ไม่พบ <span className="text-danger fw-semibold">{excelNotFound.length}</span> รายการ</>}
          </div>

          {excelMatched.length > 0 && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted fs-sm">เลือกแล้ว {excelMatched.filter(s => s.selected).length} คน</span>
                <div className="d-flex gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={() => handleToggleAllExcel(true)}>เลือกทั้งหมด</Button>
                  <Button variant="outline-secondary" size="sm" onClick={() => handleToggleAllExcel(false)}>ล้างการเลือก</Button>
                </div>
              </div>
              <div style={{ maxHeight: 320, overflowY: 'auto' }}>
                <Table responsive hover size="sm" className="mb-0">
                  <thead className="table-secondary">
                    <tr>
                      <th style={{ width: 40 }} className="text-center">#</th>
                      <th style={{ width: 120 }} className="text-center">เลขประจำตัว</th>
                      <th>ชื่อ-สกุล</th>
                      <th style={{ width: 50 }} className="text-center">เลือก</th>
                    </tr>
                  </thead>
                  <tbody>
                    {excelMatched.map((s, idx) => (
                      <tr key={s.st_id} className={!s.selected ? 'text-muted' : ''}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-center">{s.st_idnumber}</td>
                        <td>{s.st_name}</td>
                        <td className="text-center">
                          <input type="checkbox" checked={s.selected} onChange={() => handleToggleExcelStudent(s.st_id)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {excelNotFound.length > 0 && (
            <div className="alert alert-warning mt-3 mb-0 py-2">
              <div className="fw-semibold mb-1"><i className="ri-error-warning-line me-1"></i>ไม่พบเลขประจำตัวเหล่านี้ในระบบ</div>
              <div className="fs-sm" style={{ maxHeight: 120, overflowY: 'auto' }}>
                {excelNotFound.join(', ')}
              </div>
            </div>
          )}

          {excelMatched.length === 0 && (
            <div className="text-center text-muted py-3">ไม่พบนักเรียนที่ตรงกับเลขประจำตัวในไฟล์</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowExcelModal(false)}>ยกเลิก</Button>
          <Button
            variant="success"
            onClick={handleBulkImportExcel}
            disabled={excelMatched.filter(s => s.selected).length === 0}
          >
            <i className="ri-file-excel-2-line me-1"></i>
            นำเข้า {excelMatched.filter(s => s.selected).length} คน
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>
            เพิ่มนักเรียนเข้าห้องเรียน
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={e => e.preventDefault()}>
            <div className="mb-3">
              <label className="form-label">เลขประจำตัวนักเรียน</label>
              <div className="input-group">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="กรุณากรอกเลขประจำตัวนักเรียน" 
                  value={formStudentId} 
                  onChange={e => {
                    setFormStudentId(e.target.value);
                    setSearchStatus(""); // Reset status เมื่อมีการพิมพ์ใหม่
                  }} 
                />
                <Button
                  variant="outline-primary"
                  type="button"
                  onClick={handleFindStudent}
                >
                  <i className="ri-search-line"></i> ค้นหา
                </Button>
              </div>
              {/* แสดง label สถานะการค้นหา */}
              {searchStatus === "found" && (
                <small className="text-success">
                  <i className="ri-check-line"></i> พบข้อมูลนักเรียน
                </small>
              )}
              {searchStatus === "not_found" && (
                <small className="text-danger">
                  <i className="ri-close-line"></i> ไม่พบข้อมูลนักเรียน
                </small>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">ชื่อ-สกุล</label>
              <input 
                type="text" 
                className="form-control" 
                value={formStudentName} 
                onChange={e => setFormStudentName(e.target.value)} 
                readOnly={searchStatus !== "not_found"} // เฉพาะเมื่อพบข้อมูลจึงเป็น readOnly
                placeholder={searchStatus === "not_found" ? "กรุณากรอกชื่อ-สกุล" : ""}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>ปิด</Button>
          <Button variant="success" onClick={handleAddStudent} disabled={!formStudentId}>
            ตกลง
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}